import { combineReducers } from 'redux';
import { userReducer } from './user.reducer';
import { commonReducer } from './common.reducer';
import { bookingReducer } from './booking.reducer';
import { locationReducer } from './location.reducer';

const reducers = combineReducers({
  common: commonReducer,
  user: userReducer,
  booking: bookingReducer,
  location: locationReducer,
});

export default reducers;
